export type ProductsData = {
  title: string;
  description?: string;
  items: Array<string>;
};

export const PRODUCTS: Array<ProductsData> = [
  {
    title: "Capabilities:",
    items: [
      "3-Axis Milling",
      "4-Axis Milling",
      "5-Axis Milling",
      "Turning Centers",
      "Conventional Machining",
      "Wire EDM",
      "Small Hole EDM",
      "Sinker EDM",
      "3D Printing",
      "Casting",
      "Extrusions",
      "Injection Molding",
      "Grinding",
      "Assembly",
    ],
  },
  {
    title: "Materials:",
    description: "PartsBadger has the capability of running all materials. Most materials are readily available with our standard and expedited lead times. Have a custom requirement? Let us know; we are happy to accommodate custom materials.",
    items: [
      "Aluminum",
      "Copper Alloys",
      "Steel",
      "Steel Alloys",
      "Stainless Steels",
      "Plastics",
      "Composites",
      "High Performance",
      "Alloys",
      "Exotics",
    ],
  },
  {
    title: "Coatings & Secondary Processes:",
    items: [
      "Heat Treating, Induction Hardening, Case Hardening",
      "Anodizing Type I, Type II, and Type II MIL-A-8625",
      "Chromate Conversion MIL-DTL-5541",
      "Electropolishing",
      "Powder Coating",
      "Passivation ASTM A967, AMS2700, ASTM A380",
      "Black Oxide MIL-DTL-13924",
      "Nickel and Silver Electroplating",
      "Ceramic Coatings (Cerakote H-240)",
      "Dow 7 MIL-M-3171/Type III",
      "Dow 9 MIL-M-3171C/Type IV",
      "Laser Engraving",
      "Breadblasting, Polishing, Brushing, Tumbling",
      "Knurling",
    ],
  },
];
